var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-main-inner',[_c('layout-card-wrap',[_c('el-row',{attrs:{"gutter":12}},_vm._l((_vm.settings),function(item,index){return _c('el-col',{key:index,attrs:{"span":6}},[_c(item.componentName,{tag:"component",attrs:{"config":item}})],1)}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }